import { VulnerabilitiesSeverity } from '@models';

export interface RootVulnerabilitiesSeverityResult {
  vulnerabilitiesSeverity: VulnerabilitiesSeverity;
}
